export const CAROUSEL_ITEM = {
  'DASHBOARD': 0,
  'CPD_KPI': 1,
};

export const items = [
  {'index': CAROUSEL_ITEM.DASHBOARD},
  {'index': CAROUSEL_ITEM.CPD_KPI},
];

export const RETURN_TIME = 30;
